import { render, staticRenderFns } from "./uploadCom.vue?vue&type=template&id=9dce7ee4&scoped=true"
import script from "./uploadCom.vue?vue&type=script&lang=js"
export * from "./uploadCom.vue?vue&type=script&lang=js"
import style0 from "./uploadCom.vue?vue&type=style&index=0&id=9dce7ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dce7ee4",
  null
  
)

export default component.exports